import $ from 'jquery';

import {getEndpoint, getHeaders} from '../../helpers/endpoint';

export const REQUEST_FETCH_TDS = 'REQUEST_FETCH_TDS';
export const SUCCESS_FETCH_TDS = 'SUCCESS_FETCH_TDS';
export const FAIL_FETCH_TDS = 'FAIL_FETCH_TDS';

export const fetchTds = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_TDS, payload, scope});
    fetch(getEndpoint('fetchTds', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_TDS,
            error: data.error,
            payload,
            scope,
          });
        else {
          if (payload.onSuccess) {
            payload.onSuccess(data);
          }
          dispatch({
            type: SUCCESS_FETCH_TDS,
            receivedAt: Date.now(),
            data,
            success: true,
            payload,
            scope,
          });
        }
      })
      .catch((error, type = FAIL_FETCH_TDS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

export const POST_PLAYER_STATE = 'POST_PLAYER_STATE';
export const POST_PLAYER_STATE_SUCCESS = 'POST_PLAYER_STATE_SUCCESS';
export const POST_PLAYER_STATE_ERROR = 'POST_PLAYER_STATE_ERROR';

export const postPlayerState = (payload, scope) => {
  const {id, type, value} = payload;

  return (dispatch, getState) => {
    dispatch({type: POST_PLAYER_STATE, payload, scope});

    fetch(getEndpoint('postTds', payload), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({
        id: id,
        type: type,
        value: value,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: POST_PLAYER_STATE_ERROR,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successPostPlayerState(data, payload, scope));
      });
  };
};

function successPostPlayerState(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: POST_PLAYER_STATE_SUCCESS,
      receivedAt: Date.now(),
      success: true,
      payload,
      scope,
    });
  };
}

export const GET_OPTA_STATE = 'GET_OPTA_STATE';
export const GET_OPTA_STATE_SUCCESS = 'GET_OPTA_STATE_SUCCESS';
export const GET_OPTA_STATE_ERROR = 'GET_OPTA_STATE_ERROR';

export const getOpta = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: GET_OPTA_STATE, payload, scope});

    fetch(getEndpoint('getOptaState', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: GET_OPTA_STATE_ERROR,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successGetOpta(data, payload, scope));
      });
  };
};

function successGetOpta(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: GET_OPTA_STATE_SUCCESS,
      receivedAt: Date.now(),
      success: true,
      payload,
      scope,
    });
  };
}

export const GET_OPTA_PICTURE = 'GET_OPTA_PICTURE';
export const GET_OPTA_PICTURE_SUCCESS = 'GET_OPTA_PICTURE_SUCCESS';
export const GET_OPTA_PICTURE_ERROR = 'GET_OPTA_PICTURE_ERROR';

export const getOptaPicture = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: GET_OPTA_PICTURE, payload, scope});

    fetch(getEndpoint('getOptaPicture', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: GET_OPTA_PICTURE_ERROR,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successGetOptaPicture(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_TDS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successGetOptaPicture(response, payload, scope) {
  window.location.replace(process.env.API_PATH + '/' + response.link);
  $('#myModal').modal('hide');
  return dispatch => {
    dispatch({
      type: GET_OPTA_PICTURE_SUCCESS,
      receivedAt: Date.now(),
      success: true,
      payload,
      scope,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/entities/tds.js